import React, { Component } from 'react';

import TrackingDetailsHistoryList from '../../../../pages/Tracking/components/Details/History/List';

import './styles.css';

class History extends Component {
  render() {
    const {
      currentManifest,
    } = this.props;

    return (
      <div className="ManifestsInTransit__History">
        <TrackingDetailsHistoryList
          data={currentManifest.forecastHistories || []}
        />
      </div>
    );
  }
}

export default History;
